import { UseFormReturn } from "react-hook-form";
import { ProjectDetailsFormData } from "./schema";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function ProjectDetailsForm({ form }: { form: UseFormReturn<ProjectDetailsFormData> }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Sinopse - Full width textarea */}
      <div className="md:col-span-2">
        <FormField
          control={form.control}
          name="sinopse"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-white font-bold text-base">Sinopse <span className="text-red-500">*</span></FormLabel>
              <FormControl>
                <Textarea placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      {/* Negociação */}
      <FormField
        control={form.control}
        name="negociacao"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-bold text-base">Negociação <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Etapa */}
      <FormField
        control={form.control}
        name="step"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-bold text-base">Etapa <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Protocolo ou Registro da obra Biblioteca Nacional */}
      <FormField
        control={form.control}
        name="protocol"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-bold text-base">Protocolo ou Registro da obra Biblioteca Nacional <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Janelas de Exibição */}
      <FormField
        control={form.control}
        name="janelas_exibicao"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-bold text-base">Janelas de Exibição <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* UF */}
      <FormField
        control={form.control}
        name="uf"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-bold text-base">UF <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Select
                onValueChange={(value: string) => {
                  field.onChange(value);
                }}
                value={field.value}
              >
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Selecione" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="Acre">Acre</SelectItem>
                  <SelectItem value="Alagoas">Alagoas</SelectItem>
                  <SelectItem value="Amapá">Amapá</SelectItem>
                  <SelectItem value="Amazonas">Amazonas</SelectItem>
                  <SelectItem value="Bahia">Bahia</SelectItem>
                  <SelectItem value="Ceará">Ceará</SelectItem>
                  <SelectItem value="Distrito Federal">Distrito Federal</SelectItem>
                  <SelectItem value="Espírito Santo">Espírito Santo</SelectItem>
                  <SelectItem value="Goiás">Goiás</SelectItem>
                  <SelectItem value="Maranhão">Maranhão</SelectItem>
                  <SelectItem value="Mato Grosso">Mato Grosso</SelectItem>
                  <SelectItem value="Mato Grosso do Sul">Mato Grosso do Sul</SelectItem>
                  <SelectItem value="Minas Gerais">Minas Gerais</SelectItem>
                  <SelectItem value="Pará">Pará</SelectItem>
                  <SelectItem value="Paraíba">Paraíba</SelectItem>
                  <SelectItem value="Paraná">Paraná</SelectItem>
                  <SelectItem value="Pernambuco">Pernambuco</SelectItem>
                  <SelectItem value="Piauí">Piauí</SelectItem>
                  <SelectItem value="Rio de Janeiro">Rio de Janeiro</SelectItem>
                  <SelectItem value="Rio Grande do Norte">Rio Grande do Norte</SelectItem>
                  <SelectItem value="Rio Grande do Sul">Rio Grande do Sul</SelectItem>
                  <SelectItem value="Rondônia">Rondônia</SelectItem>
                  <SelectItem value="Roraima">Roraima</SelectItem>
                  <SelectItem value="Santa Catarina">Santa Catarina</SelectItem>
                  <SelectItem value="São Paulo">São Paulo</SelectItem>
                  <SelectItem value="Sergipe">Sergipe</SelectItem>
                  <SelectItem value="Tocantins">Tocantins</SelectItem>
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* País */}
      <FormField
        control={form.control}
        name="country"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-bold text-base">País (es) <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Valor aprovado */}
      <FormField
        control={form.control}
        name="approvedValue"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-bold text-base">Valor aprovado <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite seu nome" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Valor captado */}
      <FormField
        control={form.control}
        name="capturedValue"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-bold text-base">Valor captado <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Idioma */}
      <FormField
        control={form.control}
        name="language"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-bold text-base">Idioma <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Tempo */}
      <FormField
        control={form.control}
        name="time"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-bold text-base">Tempo Total <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}